export default __webpack_public_path__ + "static/media/kanban2.a7d66791.png";